function importComponent(name, ...params) {
  let mod = null
  if (name === 'gallery') {
    mod = import('../config/photoswipe')
  }
  mod.then(func => func.default(...params))
}

export default importComponent
